import { Paper } from '@material-ui/core';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { submitLogin } from '../../api/login';
import { ApiContext } from '../../contexts/ApiContext';
import { AuthContext } from '../../contexts/AuthContext';
import { mainishStyles } from '../../styling';
import { SnackbarAlert, useSnackBar } from '../Common/SnackBarContext';
import { DisplayStatus } from './DisplayStatus';
import DocumentDown from './DocumentDown';
import UpdateTasks from './UpdateTasks';

export function UpdateForm() {
  const mainishclasses = mainishStyles();
  const apiContext = useContext(ApiContext);
  const authContext = useContext(AuthContext);
  const history = useHistory();

  const [userTicketStatus, setUserTicketStatus] = useState(0);

  const snackBarHelper = useSnackBar();

  if (!authContext?.authenticated || !authContext?.auth) {
    history.push('/login');
  }

  const getTicketStatus = useCallback(async (ticketId) => {
    try {
      const res = await submitLogin(apiContext.axios, { Token: ticketId });
      setUserTicketStatus(res.data.status);
    } catch (e) {
      snackBarHelper.openSnackBar('error', String(e));
    }
  }, []);

  useEffect(async () => {
    if (authContext?.authenticated && authContext?.auth) {
      const id = authContext?.auth;
      await getTicketStatus(id);
    }
  }, [submitLogin]);

  let ContentCompoent = <></>;

  if (userTicketStatus === 1) {
    ContentCompoent = <UpdateTasks />;
  } else if (userTicketStatus === 3) {
    ContentCompoent = (
      <Paper className={mainishclasses.pageContent}>
        <DocumentDown />
      </Paper>
    );
  }

  return (
    <>
      <DisplayStatus ticketStatus={userTicketStatus} />
      {ContentCompoent}
      <SnackbarAlert />
    </>
  );
}
